module.exports = __webpack_public_path__ + "media/images/photo/top/album/album7-fd8dd41ea24b295dff2e36dc725c78d9.jpg";